import Link from "next/link";

import { getLoginToken, useShopId } from "../../core/login.core";
import { useTranslation } from "../../core/translation.core";

export default function ExportFullShop() {
  const { t, msg } = useTranslation();
  const shopId = useShopId();
  const loginToken = getLoginToken();

  return (
    <>
      <Link
        className="mt-4 border bg-blue-200 dark:bg-blue-800 px-2 py-1 rounded-sm"
        href={process.env.NEXT_PUBLIC_URL_ROOT + `/admin/export/fullShop?loginTokenAdmin=${loginToken}&shopId=${shopId}`}
      >
        {t(msg.import.exportWholeShop)}
      </Link>
    </>
  );
}
